import React, { Component } from 'react';
import './Micro.css';

import Cell from '../Cell/Cell';

class Micro extends Component {
  constructor(props) {
    super(props);

    this.state = { winner: '' }
  }

  render() {
    let elements = [];

    // Process one row at a time
    for (var y = 0; y < 3; y++) {
      let row = [];
      for (var x = 0; x < 3; x++) {
        row.push((<Cell key={ x } currentPlayer={ this.props.player } onClick={ this.props.onClick.bind(this, x, y) } owner={ this.props.board[x][y] } />))
      }

      elements.push(row);
    }

    return (
      <div className="Micro-Wrapper" >
        <div className={`Micro-Board ${ this.props.winner }`} disabled={ !this.props.active || this.props.winner !== '' }>
          { elements.map((row, y) => { return (<div key={ y }>{ row }</div>) }) }
        </div>
      </div>
    );
  }
}

export default Micro;



// WEBPACK FOOTER //
// ./src/Game/Micro/Micro.js